<template>
  <section
    :class="{
      'activity-stage': true,
      'mobile-aa-activity-stage': isMobileAAActivity,
      [customRootContainerClass]: !!customRootContainerClass
    }"
    :style="customRootContainerStyles"
  >
    <article v-if="isMobileAAActivity" id="mobile-aa-activity-header"></article>
    <article :style="customScrollContainerStyles" id="scroll-container">
      <slot name="instructions"></slot>
      <article class="content-container" :style="customContentContainerStyles">
        <slot name="content"></slot>
      </article>
    </article>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'activity-stage',
  props: {
    customRootContainerClass: {
      default: '',
      type: String,
      required: false
    },
    customRootContainerStyles: {
      default: () => ({}),
      type: Object,
      required: false
    },
    customContentContainerStyles: {
      default: () => ({}),
      type: Object,
      required: false
    },
    customScrollContainerStyles: {
      default: () => ({}),
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState('application', { isMobile: state => state.device.isMobile }),
    isMobileAAActivity() {
      return this.isAssessmentAcceleratorActivity() && this.isMobile;
    }
  },
  methods: {
    ...mapGetters('activity', ['isAssessmentAcceleratorActivity'])
  }
};
</script>

<style lang="scss" scoped>
.content-container {
  height: calc(100% - 45px);
}

#mobile-aa-activity-header {
  background-color: #ffffff;
  height: 70px;
  left: 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;
}

#scroll-container {
  height: 100%;
  overflow: auto;
  position: relative;
}
</style>
